import { useMemo } from "react";
import { useSelector } from "react-redux";

/**
 * Use Grouped Audit Validation
 *  This will disable location switch and group audit submission
 * 1. User shouldn't submit if an asset is checked from the current audit
 * 2. If the signature enabled user shouldn't switch location or submit without taking signature
 */

export default (assigned, auditId, type, assetCount) => {
    const { auditUpload } = useSelector((state) => state);
    const disable = useMemo(() => {
        if (assigned === 0) return false;
        if (assetCount && assetCount === 0 && type === "button") return false;
        if (assigned > 0 && auditUpload[auditId] && auditUpload[auditId]) {
            /** If required signature form details are not filled */
            const {
                dealerContactName,
                dealerContactEmail,
                dealerContactRole,
                dealerContactSignature,
                auditorSignature,
            } = auditUpload[auditId].auditSignature;

            if (
                dealerContactName?.length > 0 &&
                dealerContactEmail?.length > 0 &&
                dealerContactRole !== "" &&
                dealerContactSignature?.length > 0 &&
                auditorSignature?.length > 0
            )
                return false;
            else return true;
        } else return true;
    }, [auditUpload, assigned, auditId]);
    return disable;
};
